import { getRestoLogin, getToken, getUser } from "../Utils/Common";
import {
  getAPICall,
  postAPICall,
  postAPICall2,
  putAPICall,
} from "./axiosMethodCalls";

const API_URL =
  getRestoLogin() === "dreamnest"
    ? process.env.REACT_APP_BRIQUE_API
    : process.env.REACT_APP_ETTAS_API;

//GET
export const getShowMenuManager = async (id) => {
  try {
    const response = await getAPICall(API_URL + "menus/show/" + id);
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAllMenuManager = async (restoType) => {
  try {
    const response =
      restoType === "dreamnest"
        ? await getAPICall(process.env.REACT_APP_BRIQUE_API + "menus/getAll")
        : await getAPICall(process.env.REACT_APP_ETTAS_API + "menus/getAll");
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

//GET
export const getAllByCategoryMenuManager = async (category_id) => {
  try {
    const response = await getAPICall(API_URL + "menus/category", {
      category_id: category_id,
    });
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//GET
export const createMenuManager = async (
  data,
  computedVat,
  packageDetails
) => {
  try {
    var formData = new FormData();

    packageDetails.map((data) => {
      formData.append("menu[]", data.value ? data.value : "");
      formData.append("menu_name[]", data.name ? data.name : "");
      formData.append("menu_qty[]", data.qty);
      formData.append("menu_unit[]", data.unit);
    });
    if(data.is_modifier === "0"){
      data.categories.map((info) => {
        formData.append("categories[]", info.value);
      });
      data.modifiers.map((info) => {
        formData.append("modifiers[]", info);
      });
      formData.append("with_modifier", data.with_modifier);
    }
    formData.append("is_modifier", data.is_modifier);
    formData.append("effective_date", data.effective_date);
    formData.append("is_addon", data.is_addon);
    formData.append("qty", data.qty);
    formData.append("remarks", data.remarks);
    formData.append("is_package", data.is_package);
    formData.append("is_dine_in", data.is_dine_in);
    formData.append("is_take_out", data.is_take_out);
    formData.append("is_delivery", data.is_delivery);
    formData.append("suspend_sale", data.suspend_sale);
    formData.append("quick_menu", data.quick_menu);
    formData.append("sold_by_weight", data.sold_by_weight);
    formData.append("weight", data.weight);
    formData.append("open_price", data.open_price);
    formData.append("with_discount", data.with_discount);
    formData.append("is_addon", data.is_addon);
    formData.append("file", "");
    formData.append("name", data.name);
    formData.append("price", data.price);
    formData.append("takeout_price", data.takeout_price);
    formData.append("foodpanda_price", data.foodpanda_price);
    formData.append("grab_price", data.grab_price);
    formData.append("vat_in", data.price);
    formData.append("is_vatable", data.is_vatable);
    formData.append("vat_ex", data.vat_ex);
    formData.append("vat_component", data.vat_component);
    // formData.append("vat_ex", computedVat.vat_ex);
    // formData.append(
    //   "vat_component",
    //   data.is_vatable ? 0 : computedVat.vat_component
    // );
    formData.append("other_charges", data.other_charges);
    formData.append("description", data.description);
    formData.append("item_code", data.item_code);
    formData.append("menu_location", data.menu_location);
    formData.append("default_printer", data.default_printer);
    formData.append("requester", getUser());
    formData.append("token", getToken());

    const response = await postAPICall2(API_URL + "menus/create", formData);
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateMenuManager = async (
  data,
  computedVat,
  packageDetails,
) => {
  try {
    let data_arr = [];
    if (Array.isArray(data.default_categories)) {
      data_arr = data.default_categories;
    } else {
      data_arr.push({ ...data.default_categories });
    }
 
    var formData = new FormData();
    if(data.is_modifier === "0"){
      data_arr.map((info) => {
        formData.append("categories[]", info.value);
      });
      data.menu_modifiers.map((info) => {
        formData.append("modifiers[]", info);
      });
      formData.append("with_modifier", data.with_modifier);

    }
    packageDetails.map((data) => {
      formData.append("menu[]", data.menu_id ? data.menu_id : "");
      formData.append("menu_name[]", data.name ? data.name : "");
      formData.append("menu_qty[]", data.qty);
      formData.append("menu_unit[]", data.unit);
    });
    formData.append("is_package", data.is_package);
    formData.append("is_modifier", data.is_modifier);
    formData.append("effective_date", data.effective_date);
    formData.append("is_addon", data.is_addon);
    formData.append("qty", data.qty);
    formData.append("is_dine_in", data.is_dine_in);
    formData.append("is_take_out", data.is_take_out);
    formData.append("is_delivery", data.is_delivery);
    formData.append("suspend_sale", data.suspend_sale);
    formData.append("open_price", data.open_price);
    formData.append("with_discount", data.with_discount);
    formData.append("is_addon", data.is_addon);
    formData.append("name", data.name);
    formData.append("price", data.price);
    formData.append("takeout_price", data.takeout_price);
    formData.append("foodpanda_price", data.foodpanda_price);
    formData.append("grab_price", data.grab_price);
    formData.append("vat_in", data.vat_in);
    formData.append("is_vatable", data.is_vatable);
    formData.append("vat_ex", data.vat_ex);
    formData.append("vat_component", data.vat_component);
    formData.append("other_charges", data.other_charges);
    formData.append("item_code", data.item_code);
    formData.append("menu_location", data.menu_location);
    formData.append("default_printer", data.default_printer);
      // formData.append("vat_ex", computedVat.vat_ex);
    // formData.append(
    //   "vat_component",
    //   data.is_vatable ? 0 : computedVat.vat_component
    // );
    // formData.append("description", data.description)
    formData.append("requester", getUser());
    formData.append("token", getToken());
    const response = await postAPICall(
      API_URL + "menus/update/" + data.id,
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//GET
export const deleteMenuManager = async (id) => {
  try {
    const params = new URLSearchParams();
    params.append("updated_by", getUser());
    params.append("token", getToken());

    const response = await putAPICall(API_URL + "menus/delete/" + id, params);
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//GET
export const inventory = async (id, qty) => {
  try {
    const params = new URLSearchParams();
    params.append("updated_by", getUser());
    params.append("token", getToken());
    params.append("qty", qty);

    const response = await putAPICall(
      API_URL + "menus/inventory/" + id,
      params
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
